import { render, staticRenderFns } from "./NetsuiteOrders.vue?vue&type=template&id=057f1355&scoped=true&"
import script from "./NetsuiteOrders.vue?vue&type=script&lang=js&"
export * from "./NetsuiteOrders.vue?vue&type=script&lang=js&"
import style0 from "./NetsuiteOrders.vue?vue&type=style&index=0&id=057f1355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f1355",
  null
  
)

export default component.exports